import React, { Component } from 'react';
import axios from 'axios';
import {
  NavLink,
  Redirect
} from 'react-router-dom';


class Order extends Component {


  constructor(props) {
    super(props);
    this.state = {
      title: '',
      body: '',
      success: '',
      error: '',
      getuuid: '',
      keyword: '',
      tumsiralama: [],
      ilkucsiralama: [],
      count: 180
    };

    this.sidebarShow = this.sidebarShow.bind(this);

  }

  sidebarShow(event) {
    document.getElementById("sidebar").classList.add('active_sidebar')
  }

  renderUserLinks() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
      return (
        <span className="">
          <NavLink className="d-none me-2 small link-dark text-decoration-none" to="/user/profile">
            <i className="fa fa-user-circle"></i> Hesap
          </NavLink>
          <NavLink className="text-decoration-none" to="/user/logout">
            Çıkış Yap
          </NavLink>
        </span>
      );
    }
    else {
      return (
        <span>
          <NavLink className="" activeClassName="active" to="/user/login">
            <i className="fa fa-sign-in"></i> Giriş
          </NavLink>
        </span>
      );
    }
  }

  renderUserName() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          {userLinkTitle} 
        </span>
      );
    }
    else {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          Kullanici {userLinkTitle} 
        </span>
      );
    }
  }




  componentDidMount() {
  
    var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
    var auth2 = localStorage.getItem('auth');
  
  	console.log(uid);
  	console.log(auth);
  	console.log(auth2);
  
    var self = this;
  
    this.serverRequest = axios.get('https://api.efeskiyafetportali.com/user/' + uid + '?_format=json', {
      headers: {"Authorization":"Basic " + auth2}
    })
    .then(function(result){
      var userDate = new Date(parseInt(result.data.created["0"].value, 10)*1000);
      self.setState({
        'name': result.data.name["0"].value,
        'field_ad': result.data.field_ad["0"].value,
        'field_soyad': result.data.field_soyad["0"].value,
        'field_alan': result.data.field_alan["0"].value,
        'date': userDate.toISOString()
      });
    })

  
  
  
  
  
  }





  render(){
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
        return (
        <section className="main_content dashboard_part">
            <div className="container pt-3">
            
            
            
            
                <div className="row">
                
               
                
                
                    <div className="col-lg-4">
                    
                     <div className="alan"> {this.state.field_alan} </div>
                    
                    
                    
                        <div className="header_iner">

                            <div className="header_right d-flex justify-content-between align-items-center mb-3">
                                <NavLink className="text-decoration-none me-3" to="/user/profile"> {this.state.field_ad} {this.state.field_soyad}</NavLink>
                                <div className="text-center me-3">{this.renderUserLinks()}</div>
                            </div>
                    <div className="fs-6 mb-1">Anadolu Efes Ekibi</div>
                    <div className="fs-6 mb-1">Bayii ve Dist. Ekibi</div>
                    <div className="fs-6 mb-1">Ajans Merch</div>
                        </div>
                    </div>
                    <div className="col-sm-8 mb-4 mb-lg-0">
                    
                    <div className="d-flex fs-3 mb-3"><div>Bayi Siparişleri</div> <div className="ms-auto"><button type="button" class="btn btn-warning me-2">Bekleyen</button> <button type="button" class="btn btn-warning me-2">Onaylanan</button>
                                                                <button type="button" class="btn btn-warning">Tamamlanan</button></div></div>
                    
                    
                        <div className="border border-light-subtle bg-light rounded-4 mb-3">
                                                    <div class="mx-4 my-3">
                                                        <div class="row align-items-center mb-2 top-header text-light rounded-4">
                                                            <div class="col-md-2">
                                                                <div class="rounded-end-4 ms-3 py-2">11640</div>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <div class="rounded-end-4 ms-3 py-2">EDİRNE-TRK</div>
                                                            </div>
                                                            <div class="col-md-4 text-end">
                                                                <div class="rounded-end-4 py-2">
                                                                <button type="button" class="btn btn-warning me-2">Onayla</button>
                                                                <button type="button" class="btn btn-warning">Tedarikçi ></button>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Ürün Kodu</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Ürün Adı</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Cinsiyet</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Ürün Bedeni</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Ürün Adedi</div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">0b66</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Toplantı Gömleği</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Kadın</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">S</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">20</div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">402f</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Toplantı Gömleği</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Kadın</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">M</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">21</div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">93ec</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Beyaz Tshirt</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Erkek</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">S</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">20</div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">9cac</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Bermuda Şort</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Erkek</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">S</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">20</div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">4a4f</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Yağmurluk 2025</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Erkek</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">S</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">20</div>
                                                            </div>
                                                        </div>
                                                    </div>


                        </div>





                        <div className="border border-light-subtle bg-light rounded-4">
                                                    <div class="mx-4 my-3">
                                                        <div class="row align-items-center mb-2 top-header text-light rounded-4">
                                                            <div class="col-md-2">
                                                                <div class="rounded-end-4 ms-3 py-2">11779</div>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <div class="rounded-end-4 ms-3 py-2">KEŞAN-TRK</div>
                                                            </div>
                                                            <div class="col-md-4 text-end">
                                                                <div class="rounded-end-4 py-2">
                                                                <button type="button" class="btn btn-warning me-2">Onayla</button>
                                                                <button type="button" class="btn btn-warning">Tedarikçi ></button>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Ürün Kodu</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Ürün Adı</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Cinsiyet</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Ürün Bedeni</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Ürün Adedi</div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">93ec</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Beyaz Tshirt</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Erkek</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">S</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">20</div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">93ec</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Beyaz Tshirt</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Kadın</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">S</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">20</div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">9cac</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Bermuda Şort</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Kadın</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">S</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">20</div>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">4a4f</div>
                                                            </div>
                                                            <div class="col-md-3 rounded-end-4">
                                                                <div class="rounded-end-4 ms-3 py-2">Yağmurluk 2025</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">Erkek</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">S</div>
                                                            </div>
                                                            <div class="col-md-2 text-end">
                                                                <div class="rounded-end-4 ms-3 py-2">20</div>
                                                            </div>
                                                        </div>
                                                    </div>


                        </div>



                    </div>
                </div>
            </div>
        </section>


        );
    } else {
        return (



          <div className="row top-buffer">
            <Redirect to="/user/login" />
          </div>



        );
    }
  }
}

export default Order



// WEBPACK FOOTER //
// src/components/order.jsx